import { FormInstance } from "antd/es/form";
import React from "react";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Header2_ScreenContext } from "../header2/header2-context";

declare let window: any;

export interface IProductSearchInfo_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IProductSearchInfo_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
}

export class ProductSearchInfo_ScreenBase extends React.PureComponent<
  IProductSearchInfo_ScreenProps,
  any
> {
  static contextType = Header2_ScreenContext;
  declare context: React.ContextType<typeof Header2_ScreenContext>;
  productsearchinfo_122538_value_kuikaTableRef: React.RefObject<any>;
  productsearchinfo_459019_value_kuikaPaginationRef: React.RefObject<any>;
  productsearchinfo_106020_value_kuikaTableRef: React.RefObject<any>;
  productsearchinfo_723902_value_kuikaTableRef: React.RefObject<any>;
  productsearchinfo_893858_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "886333e7-e577-410b-93fb-9f19f5c71795",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 66881, PropertyName: "value", Value: "Ürün Sorgulama" },
        { Id: 153494, PropertyName: "value", Value: "Ürün Kod" },
        { Id: 825864, PropertyName: "value", Value: "Ürün Tanım" },
        { Id: 385580, PropertyName: "value", Value: "Renk" },
        { Id: 101703, PropertyName: "value", Value: "Mavi" },
        { Id: 125126, PropertyName: "value", Value: "Boyut" },
        { Id: 147307, PropertyName: "value", Value: "label" },
        { Id: 567327, PropertyName: "value", Value: "Mağaza Envanteri" },
        { Id: 485472, PropertyName: "value", Value: "label" },
        { Id: 18189, PropertyName: "tab", Value: "Özellik" },
        { Id: 950474, PropertyName: "title", Value: "Title" },
        { Id: 233628, PropertyName: "value", Value: "Özellik Adı" },
        { Id: 963260, PropertyName: "value", Value: "Özellik Tanımı" },
        { Id: 554977, PropertyName: "value", Value: "Özellik Adı" },
        { Id: 482632, PropertyName: "value", Value: "Özellik Tanımı" },
        { Id: 719103, PropertyName: "tab", Value: "Varyantlar" },
        { Id: 338724, PropertyName: "title", Value: "Title" },
        { Id: 354567, PropertyName: "value", Value: "Renk Tanımı" },
        { Id: 442182, PropertyName: "value", Value: "Ürün Kod" },
        { Id: 148595, PropertyName: "value", Value: "Stok" },
        { Id: 530453, PropertyName: "tab", Value: "Envanter" },
        { Id: 256798, PropertyName: "title", Value: "Title" },
        { Id: 912708, PropertyName: "value", Value: "Merkez Depo" },
        { Id: 64630, PropertyName: "value", Value: "stok" },
        { Id: 762025, PropertyName: "tab", Value: "Notlar" },
        { Id: 75966, PropertyName: "tab", Value: "Fiyatlar" },
        { Id: 542104, PropertyName: "title", Value: "Title" },
        { Id: 976401, PropertyName: "value", Value: "Maliyet Fiyatı" },
        { Id: 779605, PropertyName: "value", Value: "label" },
        { Id: 122663, PropertyName: "value", Value: "Satın Alma Fiyatı" },
        { Id: 468644, PropertyName: "value", Value: "label" },
        { Id: 372513, PropertyName: "value", Value: "Satış Fiyatı" },
        { Id: 770732, PropertyName: "value", Value: "label" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.productsearchinfo_122538_value_kuikaTableRef = React.createRef();
    this.productsearchinfo_459019_value_kuikaPaginationRef = React.createRef();
    this.productsearchinfo_106020_value_kuikaTableRef = React.createRef();
    this.productsearchinfo_723902_value_kuikaTableRef = React.createRef();
    this.productsearchinfo_893858_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "productsearchinfo",
        "header2_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "productsearchinfo",
      "header2_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "productsearchinfo",
      "header2_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  checkTabErrors = () => {
    document.querySelectorAll(".rc-tabs-tab").forEach((tab) => {
      (tab as HTMLElement).style.color = "";
    });

    const tabPanes = document.querySelectorAll(".rc-tabs-tabpane");
    const tabs = document.querySelectorAll(".rc-tabs-tab");

    tabPanes.forEach((tabPane, index) => {
      const uniquePaneId = `rc-tabs-tabpane-${index}`;
      if (!tabPane.hasAttribute("id")) {
        tabPane.setAttribute("id", uniquePaneId);
      }

      const uniqueTabId = `rc-tabs-tab-${index}`;
      if (tabs[index]) {
        if (!tabs[index].hasAttribute("id")) {
          tabs[index].setAttribute("id", uniqueTabId);
        }
        tabs[index].setAttribute("aria-controls", uniquePaneId);
      }
    });

    const errorElements = document.querySelectorAll(
      ".rc-tabs .ant-form-item-explain-error"
    );

    const tabsWithErrors = new Set<string>();

    errorElements.forEach((errorElement) => {
      const tabPane = errorElement.closest(".rc-tabs-tabpane");
      if (tabPane && tabPane.id) {
        tabsWithErrors.add(tabPane.id);
      }
    });

    tabsWithErrors.forEach((tabPaneId) => {
      const tab = document.querySelector(
        `.rc-tabs-tab[aria-controls="${tabPaneId}"]`
      );
      if (tab) {
        (tab as HTMLElement).style.color = "red";
      }
    });
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
